import React, { Fragment, ReactElement } from 'react';

import {
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	ListItem,
	ListItemText,
	Paper,
} from '@material-ui/core';

import styles from './ActionSheet.module.scss';

export interface ActionSheetProps {
	open: boolean;
	title: string | ReactElement;
	children?:
		| ReactElement<ActionSheetActionProps>
		| (ReactElement<ActionSheetActionProps> | undefined)[];
	onClose: () => void;
	cancelText?: string;
}

export type ActionSheetActionClickContext = {
	handleDialogClose?: () => void;
};

export type ActionSheetAction = {
	label: string;
	type?: 'blue' | 'danger';
	onActionClick: (clickContext?: ActionSheetActionClickContext) => void;
	loading?: boolean;
};

export type ActionSheetActionProps = ActionSheetAction & {
	clickContext?: ActionSheetActionClickContext;
};

export const ActionSheet: React.FC<ActionSheetProps> = ({
	onClose,
	open,
	title,
	children,
	cancelText = 'Cancel',
}) => {
	return (
		<Dialog
			classes={{
				paper: styles['dialog_paper'],
				scrollPaper: styles['dialog'],
			}}
			onClose={onClose}
			open={open}
		>
			<Paper classes={{ root: styles['dialog__content-paper'] }}>
				<DialogTitle
					classes={{
						root: styles['dialog-title'],
					}}
					disableTypography
				>
					{title}
				</DialogTitle>
				<DialogContent
					classes={{
						root: styles['dialog__list'],
					}}
				>
					{children}
				</DialogContent>
			</Paper>
			<Paper classes={{ root: styles['dialog__actions-paper'] }}>
				<DialogActions
					classes={{
						root: styles['dialog-actions'],
					}}
				>
					<ListItem
						classes={{
							root: styles['dialog__list-item'],
						}}
						button
						onClick={onClose}
					>
						<ListItemText
							classes={{
								primary: styles['dialog__list-item-text'],
							}}
							primary={cancelText}
						/>
					</ListItem>
				</DialogActions>
			</Paper>
		</Dialog>
	);
};

export const ActionSheetAction = ({
	label,
	onActionClick,
	clickContext,
	type,
	loading,
}: ActionSheetActionProps) => {
	const listItemClasses = [
		styles['dialog__list-item-text'],
		type === 'danger' ? styles['dialog__list-item-text--danger'] : '',
	];

	return (
		<Fragment key={label}>
			<Divider
				classes={{
					root: styles['dialog__list-item-divider'],
				}}
			/>
			<ListItem
				classes={{
					root: styles['dialog__list-item'],
				}}
				button
				onClick={() => onActionClick(clickContext)}
			>
				<ListItemText
					primary={
						<div className={styles['dialog__list-item-label']}>
							{label} {loading && <CircularProgress size={20} />}
						</div>
					}
					classes={{
						primary: listItemClasses.join(' '),
					}}
				/>
			</ListItem>
		</Fragment>
	);
};
